// Jauge des remises par palier de quantité — voir snippets/lf-volume-offer.liquid
//
// L'état initial vient de Liquid : ce script ne fait que le suivre quand le
// panier change sans rechargement de page. Sa logique de message est le
// jumeau de celle du snippet, les deux doivent rester alignées.
(function () {
  if (window.lfvVolumeOffer) return;
  window.lfvVolumeOffer = true;

  var etat = { quantite: null, soustotal: 0 };

  function livres(pence) {
    return '£' + (Math.floor(pence) / 100).toFixed(2);
  }

  // Aucune projection chiffrée sur les paliers à venir : le montant
  // dépendrait du prix des paires ajoutées, qu'on ne connaît pas. Seul un
  // palier déjà acquis affiche une somme, et elle est exacte.
  function somme(pence) {
    return '<span class="lfv__amount">' + livres(pence) + '</span>';
  }

  // Compte les PAIRES EFFECTIVES (anti-abus affiné), identique à la discount function
  // et au snippet lf-pair-count : groupe par produit+couleur ; même taille en double =
  // 2 paires ; tailles différentes d'un même produit+couleur distinctes seulement si
  // écart > 3 ; produits/couleurs différents = toujours distincts.
  function comptePaires(panier) {
    var groupes = {};
    var items = (panier && panier.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var couleur = '';
      var tailleStr = '';
      if (it.options_with_values && it.options_with_values.length) {
        couleur = String(it.options_with_values[0].value || '');
        if (it.options_with_values.length > 1) tailleStr = String(it.options_with_values[1].value || '');
      } else {
        var vt = it.variant_title || '';
        var pos = vt.lastIndexOf(' / ');
        couleur = pos >= 0 ? vt.slice(0, pos) : vt;
        tailleStr = pos >= 0 ? vt.slice(pos + 3) : '';
      }
      var cle = it.product_id + '::' + couleur.trim().toLowerCase();
      var taille = parseFloat(String(tailleStr).replace(/[^0-9.]/g, ''));
      if (!isFinite(taille)) taille = null;
      var qte = it.quantity > 0 ? it.quantity : 1;
      if (!groupes[cle]) groupes[cle] = [];
      for (var q = 0; q < qte; q++) groupes[cle].push(taille);
    }
    var total = 0;
    for (var k in groupes) {
      var tailles = groupes[k].slice().sort(function (a, b) {
        if (a == null) return b == null ? 0 : -1;
        if (b == null) return 1;
        return a - b;
      });
      var compte = 0;
      var derniere = null;
      var demarre = false;
      for (var s = 0; s < tailles.length; s++) {
        var t = tailles[s];
        if (!demarre) {
          compte++;
          derniere = t;
          demarre = true;
        } else if (t === derniere) {
          compte++;
        } else if (t == null || derniere == null) {
          compte++;
          derniere = t;
        } else if (t - derniere > 3) {
          compte++;
          derniere = t;
        }
      }
      total += compte;
    }
    return total;
  }

  function message(franchis, soustotal) {
    if (franchis >= 4) {
      return '<strong>30% off your whole basket</strong> — you are saving ' +
        somme((soustotal * 30) / 100) + '. That is our best rate.';
    }

    if (franchis >= 2) {
      var acquis = franchis === 3 ? 25 : 20;
      var suivant = franchis === 3 ? 30 : 25;
      return '<strong>' + acquis + '% off your whole basket</strong> — you are saving ' +
        somme((soustotal * acquis) / 100) + '. Add 1 more pair for ' + suivant + '%.';
    }

    if (franchis === 1) {
      return '<strong>Add 1 more pair</strong> and get 20% off your whole basket.';
    }

    return '<strong>Add 2 pairs</strong> and get 20% off your whole basket.';
  }

  // Le DOM est réinterrogé à chaque passage : le tiroir panier est remplacé
  // en entier par le rendu de section, aucun noeud n'est durable.
  function rafraichir() {
    if (etat.quantite === null) return;

    var franchis = Math.min(etat.quantite, 4);

    // Jalon visé : depuis 0 ou 1 paire la cible est la même, deux paires.
    // Aucune cible une fois le palier maximum atteint.
    var suivant = franchis < 4 ? Math.max(franchis + 1, 2) : 0;

    Array.prototype.forEach.call(document.querySelectorAll('[data-lfv]'), function (racine) {
      racine.style.setProperty('--lfv-fill', Math.max(0, franchis - 1));

      Array.prototype.forEach.call(racine.querySelectorAll('[data-lfv-step]'), function (etape) {
        var rang = parseInt(etape.dataset.lfvStep, 10);
        var acquis = franchis >= rang;
        etape.classList.toggle('is-done', acquis);
        etape.classList.toggle('is-next', !acquis && rang === suivant);
      });

      var statut = racine.querySelector('[data-lfv-status]');
      if (statut) statut.innerHTML = message(franchis, etat.soustotal);
    });

    // Rappel sticky « Buy N pairs » : palier SUIVANT a debloquer, synchronise
    // avec la jauge. Masque au palier maxi (4+ paires).
    var stkTarget = franchis >= 3 ? 4 : (franchis === 2 ? 3 : 2);
    var stkPct = franchis >= 3 ? 30 : (franchis === 2 ? 25 : 20);
    var stkMax = franchis >= 4;
    Array.prototype.forEach.call(document.querySelectorAll('[data-lf-sticky-offer]'), function (so) {
      so.setAttribute('data-lf-sticky-max', stkMax ? 'true' : 'false');
      var txt = so.querySelector('[data-lf-sticky-text]');
      if (txt && !stkMax) txt.innerHTML = 'Buy ' + stkTarget + ' pairs, <strong>save ' + stkPct + '%</strong>';
    });
  }

  function lirePanier() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (panier) {
        if (!panier) return;
        etat.quantite = comptePaires(panier);
        // items_subtotal_price est déjà le montant AVANT remise de panier :
        // ne rien y ajouter, sous peine de compter la remise deux fois.
        etat.soustotal = panier.items_subtotal_price || 0;
        rafraichir();
      })
      .catch(function () {
        /* Sans réponse, l'état rendu par Liquid reste en place. */
      });
  }

  // État initial : celui que Liquid vient de rendre. Aucune requête au
  // chargement, donc aucun scintillement — /cart.js ne sert qu'ensuite.
  function amorcer() {
    var racine = document.querySelector('[data-lfv]');
    if (!racine) return;
    etat.quantite = parseInt(racine.dataset.lfvQty, 10) || 0;
    etat.soustotal = parseInt(racine.dataset.lfvSubtotal, 10) || 0;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', amorcer);
  } else {
    amorcer();
  }

  document.addEventListener('cart:updated', lirePanier);
})();
